import React from 'react';
import PropTypes from 'prop-types';

import { useUrlLocalizer, useTranslator } from 'tradera-lang/translate';
import CloseNarrowIcon from '@tradera/blueprint/theme/icons/close-narrow.svg?jsx';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';

const SearchInput = ({
    categoriesElement,
    inputClassName,
    onBlur,
    onClearSearchInput,
    onFocus,
    onFormSubmit,
    onUserInputChange,
    onUserKeyUp,
    searchInputRef,
    searchTerm,
    selectedCategory,
    suggestionsElement
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const { t } = useTranslator();

    const placeHolderTranslation =
        selectedCategory && selectedCategory.id !== 0 && selectedCategory.name
            ? t('siteHeader_categorySearchPlaceholder', {
                  categoryName: selectedCategory.name
              })
            : t('siteHeader_generalSearchPlaceholder');

    const showClearButton = searchTerm !== '';

    return (
        <form
            action={toLocalizedUrl('/search')}
            method="GET"
            autoComplete="off"
            onSubmit={onFormSubmit}
            className="slim-header__search-form row no-gutters"
            data-nav-search>
            <div className="d-none d-md-flex col-md-auto">
                {categoriesElement}
            </div>
            <div className="col">
                <input
                    aria-label={placeHolderTranslation}
                    type="text"
                    id={`site-header-search-input-${inputClassName}`}
                    className={`slim-header__search-field form-control ${inputClassName}`}
                    data-search-field
                    name="q"
                    placeholder={placeHolderTranslation}
                    maxLength="98"
                    role="search"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    ref={searchInputRef}
                    value={searchTerm || ''}
                    onChange={onUserInputChange}
                    onKeyDown={onUserKeyUp}
                />
                <fieldset className="slim-header__form-buttons">
                    {showClearButton ? (
                        <button
                            aria-label="Reset input"
                            type="reset"
                            data-search-clear
                            className="slim-header__clear-button unbutton btn h-100"
                            onClick={onClearSearchInput}>
                            <CloseNarrowIcon className="icon icon-xs" />
                        </button>
                    ) : (
                        <button
                            aria-label="Search"
                            type="submit"
                            data-search-submit
                            className="slim-header__submit-button flip-after unbutton btn btn-auto d-inline-block pr-2">
                            <SearchIcon className="icon" />
                        </button>
                    )}
                </fieldset>
                {suggestionsElement}
            </div>
        </form>
    );
};

SearchInput.propTypes = {
    categoriesElement: PropTypes.element,
    inputClassName: PropTypes.string,
    onBlur: PropTypes.func,
    onClearSearchInput: PropTypes.func,
    onFocus: PropTypes.func,
    onFormSubmit: PropTypes.func,
    onUserInputChange: PropTypes.func,
    onUserKeyUp: PropTypes.func,
    searchInputRef: PropTypes.object,
    searchTerm: PropTypes.string,
    selectedCategory: PropTypes.object,
    suggestionsElement: PropTypes.element
};

export default SearchInput;
